/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsEDRMachineMetricsLicenseCount
 */
export interface JumboStructsEDRMachineMetricsLicenseCount {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsEDRMachineMetricsLicenseCount
     */
    licenseName?: string;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineMetricsLicenseCount
     */
    unusedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineMetricsLicenseCount
     */
    usedCount?: number;
}

/**
 * Check if a given object implements the JumboStructsEDRMachineMetricsLicenseCount interface.
 */
export function instanceOfJumboStructsEDRMachineMetricsLicenseCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsEDRMachineMetricsLicenseCountFromJSON(json: any): JumboStructsEDRMachineMetricsLicenseCount {
    return JumboStructsEDRMachineMetricsLicenseCountFromJSONTyped(json, false);
}

export function JumboStructsEDRMachineMetricsLicenseCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsEDRMachineMetricsLicenseCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'licenseName': !exists(json, 'licenseName') ? undefined : json['licenseName'],
        'unusedCount': !exists(json, 'unusedCount') ? undefined : json['unusedCount'],
        'usedCount': !exists(json, 'usedCount') ? undefined : json['usedCount'],
    };
}

export function JumboStructsEDRMachineMetricsLicenseCountToJSON(value?: JumboStructsEDRMachineMetricsLicenseCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'licenseName': value.licenseName,
        'unusedCount': value.unusedCount,
        'usedCount': value.usedCount,
    };
}

